import { Toast, Tooltip } from "./_bootstrap";

(function ($) {

  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll(".toast")
    .forEach((toastElement) => new Toast(toastElement));


  /*******************************************************************************
  ** News/Articles
  *******************************************************************************/

   // Article pages behavior
  const selected = [];

  $(window).on('load', function () {
    // Set initial active category button
    $('#views-exposed-form-articles-popular-topics-block div.btn').eq(0).addClass('active');

    // Parse URL params for category IDs and update the form
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('categoryids')) {
      const categoryids = urlParams.get('categoryids').split(',');
      const sE = document.getElementById('edit-field-content-categories-target-id');
      if (sE) {
        for (let i = 0; i < sE.options.length; i++) {
          const option = sE.options[i];
          if (categoryids.includes(option.value)) {
            option.setAttribute('selected', 'selected');
            if (!selected.includes(option.value)) {
              selected.push(option.value);
              $("input[type=checkbox][id=" + option.value + "]").prop('checked', true).addClass('active');
            }
          }
        }
      }
    }
  });

  // Scroll to top command
  Drupal.AjaxCommands.prototype.scrollTop = function (ajax, response) {
    const offset = $('#ge-articles-filter').offset();
    if (offset) {
      let scrollTarget = response.selector;
      while ($(scrollTarget).scrollTop() === 0 && $(scrollTarget).parent()) {
        scrollTarget = $(scrollTarget).parent();
      }
      $(scrollTarget).animate({ scrollTop: offset.top }, 500);
    }
  };

  // Behavior for article filters and sliders
  Drupal.behaviors.mybehavior = {
    attach: function (context, settings) {
      // Reinitialize tooltips and toasts if necessary
      document.querySelectorAll('[data-toggle="tooltip"]').forEach((tooltipElement) => new Tooltip(tooltipElement));
      document.querySelectorAll('.toast').forEach((toastElement) => new Toast(toastElement));

      // Handle refine search button actions
      const refineBtn = document.querySelector(".refine-search-btn");
      const refineMobileSection = document.querySelector(".refine-section");
      const wholeListSection = document.querySelector(".list-section");
      const topBannerSection = document.querySelector(".top-img-container");

      const showHideRefineSection = (showRefineSection, listSection) => {
        if (showRefineSection) {
          refineMobileSection.classList.add("refine-list-mobile");
        }
        else {
          refineMobileSection.classList.remove("refine-list-mobile");
        }

        if (wholeListSection) {
          wholeListSection.style.display = listSection;
        }
        topBannerSection.style.display = listSection;
      };

      if (refineBtn) {
        refineBtn.addEventListener('click', () => {
          window.scrollTo(0, 0);
          showHideRefineSection(true, "none");
        });
        document.querySelector(".btn-close-icon").addEventListener('click', () => {
          showHideRefineSection(false, "block");
        });
        document.querySelector(".apply").addEventListener('click', (e) => {
          showHideRefineSection(false, "block");
          e.preventDefault();
        });

        window.addEventListener('resize', () => {
          if (document.body.clientWidth > 768) {
            showHideRefineSection(false, "block");
          }
        });
      }

      // Initialize sliders if slick is available
      $(document).ready(function () {
        if ($.fn.slick) {
          $(".slider-for").not('.slick-initialized').slick({
            slidesToShow: 2.4,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            autoplay: false,
            variableWidth: true,
            swipeToSlide: true,
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3.2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1.2,
                  slidesToScroll: 1,
                },
              },
            ],
          });
          $(".prev-btn").click(function () {
            $(".slider-for").slick("slickPrev");
          });
          $(".next-btn").click(function () {
            $(".slider-for").slick("slickNext");
          });
          $(".prev-btn").addClass("ctrl-disabled");
          $(".slider-for").on("afterChange", function () {
            if ($(".slick-prev").hasClass("slick-disabled")) {
              $(".prev-btn").addClass("ctrl-disabled");
            }
            else {
              $(".prev-btn").removeClass("ctrl-disabled");
            }
            if ($(".slick-next").hasClass("slick-disabled")) {
              $(".next-btn").addClass("ctrl-disabled");
            }
            else {
              $(".next-btn").removeClass("ctrl-disabled");
            }
          });
        }

        // Article Landing Page
        $('#views-exposed-form-articles-popular-topics-block div.btn').on('click', function(e) {
          e.preventDefault();
          selected = [];
          var selectFilter = $('#views-exposed-form-articles-popular-topics-block select[name="field_content_categories_target_id"]');
          var id = $(e.currentTarget).attr('id');
          if($(e.currentTarget).hasClass('active') == true) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
          else {
            selected.push(id);
          }

          // Set the new value in the SELECT element
          selectFilter.val(selected);

          // Do it! Trigger the select box
          //filter.trigger('change');
          $('#views-exposed-form-articles-popular-topics-block select[name="field_content_categories_target_id"]').trigger('change');
          $('#views-exposed-form-articles-popular-topics-block').find('[data-drupal-selector*=edit-submit-articles]').trigger('click');
        });

        // Article Filter Page
        //$('#views-exposed-form-articles-filter-list-page-1 input[type=checkbox]').unbind('click').on('click', function(e) {
        $('form[id^="views-exposed-form-articles-filter-list-page-"] input[type=checkbox]').unbind('click').on('click', function(e) {
          e.preventDefault();
          //var selectFilter = $('#views-exposed-form-articles-filter-list-page-1 select[name="field_content_categories_target_id[]"]');
          var selectFilter = $('form[id^="views-exposed-form-articles-filter-list-page-"] select[name="field_content_categories_target_id[]"]');

          var id = $(e.currentTarget).attr('id');
          if($(e.currentTarget).hasClass('active') == true) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
          else {
            selected.push(id);
          }

          // Set the new value in the SELECT element
          selectFilter.val(selected);

          // Do it! Trigger the select box
          //filter.trigger('change');
          // $('#views-exposed-form-articles-filter-list-page-1 select[name="field_content_categories_target_id[]"]').trigger('change');
          // $('#views-exposed-form-articles-filter-list-page-1').find('[data-drupal-selector*=edit-submit]').trigger('click');
          $('form[id^="views-exposed-form-articles-filter-list-page-"] select[name="field_content_categories_target_id[]"]').trigger('change');
          $('form[id^="views-exposed-form-articles-filter-list-page-"]').find('[data-drupal-selector*=edit-submit]').trigger('click');
        });

        $.each(selected, function(i,value){
          $('#views-exposed-form-articles-popular-topics-block div.btn').removeClass('active');
          //$('#views-exposed-form-press-releases-page-1 div.btn').not($("#"+value)).removeClass('active');
          $("input[type=checkbox][id="+value+"]").prop('checked',true).addClass('active');

          $("#"+value).addClass('active');
        });

        $('.views-exposed-form [data-drupal-selector=edit-reset]').removeClass('btn-primary');

        // Handle article filter checkboxes
        //$('#views-exposed-form-articles-filter-list-page-1 input[type=checkbox]').unbind('click').on('click', function (e) {
        $('form[id^="views-exposed-form-articles-filter-list-page-"] input[type=checkbox]').unbind('click').on('click', function (e) {
          e.preventDefault();
          //const selectFilter = $('#views-exposed-form-articles-filter-list-page-1 select[name="field_content_categories_target_id[]"]');
          const selectFilter = $('form[id^="views-exposed-form-articles-filter-list-page-"] select[name="field_content_categories_target_id[]"]');
          const id = $(e.currentTarget).attr('id');
          if ($(e.currentTarget).hasClass('active')) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1);
            }
          }
          else {
            selected.push(id);
          }

          selectFilter.val(selected);

          //$('#views-exposed-form-articles-filter-list-page-1 select[name="field_content_categories_target_id[]"]').trigger('change');
          //$('#views-exposed-form-articles-filter-list-page-1').find('[data-drupal-selector*=edit-submit]').trigger('click');
          $('form[id^="views-exposed-form-articles-filter-list-page-"] select[name="field_content_categories_target_id[]"]').trigger('change');
          $('form[id^="views-exposed-form-articles-filter-list-page-"]').find('[data-drupal-selector*=edit-submit]').trigger('click');
        });

        $.each(selected, function (i, value) {
          $('#views-exposed-form-articles-popular-topics-block div.btn').removeClass('active');
          $("input[type=checkbox][id=" + value + "]").prop('checked', true).addClass('active');
          $("#" + value).addClass('active');
        });

        // Modify classes for article comment form
        if ($('.comment-comment-form')) {
          $('input[id^=edit-cancel]').removeClass('btn');
          $('label[for^="edit-name"]').text('Name *');
          $('label[for^="edit-comment-body-0-value"]').text('Comment *');
        }
        if ($('.comment-comment-form .js-form-submit')) {
          $('input[id^=edit-ajax-comments-reply-form]').removeClass('button--primary js-form-submit form-submit btn btn-primary');
        }
        if ($('[data-drupal-selector=comment-form]')[0]) {
          if ($('.alert').hasClass('alert-success')) {
            $('[data-drupal-selector=comment-form]')[0].reset();
          }
        }
        if ($('.js-comment.by-viewer')) {
          $('.js-comment.by-viewer').each(function () {
            if ($(this).next().hasClass('indented')) {
              $(this).next().appendTo(this);
            }
          });
        }
      });
    },
  };

  /*******************************************************************************
  ** End of News/Articles
  *******************************************************************************/

})(jQuery);
